import { MessageLog } from 'models/automation/MessageLogs';
import TriggerLogTypeIcon from 'pages/automations/common/TriggerLogTypeIcon';

interface LogTypeCellProps {
  getValue: () => MessageLog['logType'];
}

const LogTypeCell = ({ getValue }: LogTypeCellProps) => {
  const type = getValue();

  return <TriggerLogTypeIcon type={type} />;
};

export default LogTypeCell;
